"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCopyButton = void 0;
const core_1 = require("@mantine/core");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const React = __importStar(require("react"));
function TableCopyButton(inputProps) {
    //const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(core_1.Center, null,
            React.createElement(core_1.CopyButton, { value: inputProps.id, timeout: 2000 }, ({ copied, copy }) => (React.createElement(core_1.Tooltip, { label: copied ? inputProps.copiedLabel : inputProps.copyLabel, withArrow: true, position: "right" },
                React.createElement(core_1.ActionIcon, { color: copied ? "teal" : "gray", onClick: copy },
                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: copied ? free_solid_svg_icons_1.faCheck : free_solid_svg_icons_1.faCopy }))))))));
}
exports.TableCopyButton = TableCopyButton;
//# sourceMappingURL=TableCopyButton.js.map